import React from "react";

const ACTION_COLORS = {
    SYNC_INITIATED: "#10b981",
    GHOST_DETECTED: "#ef4444",
    CONTACT_REMOVED: "#ef4444",
    CONTACT_INJECTED: "#10b981",
    AUTO_REMOVE_TOGGLED: "#f59e0b",
    HEAL_PIPELINE_QUERIED: "#10b981",
};

function formatTime(iso) {
    try {
        const d = new Date(iso);
        return d.toLocaleString(undefined, {
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        });
    } catch {
        return iso;
    }
}

export function AuditLogTimeline({ entries }) {
    if (!entries || entries.length === 0) {
        return (
            <div className="font-mono text-xs text-zinc-500 p-4 text-center" data-testid="audit-log-empty">
                No audit events yet — run a Sync.
            </div>
        );
    }
    return (
        <ol className="relative pl-5 border-l border-white/10 space-y-4" data-testid="audit-log-timeline">
            {entries.map((e) => {
                const color = ACTION_COLORS[e.action] || "#a1a1a1";
                return (
                    <li key={e.id} className="relative" data-testid={`audit-entry-${e.id}`}>
                        <span
                            className="absolute -left-[26px] top-1 w-2 h-2 rounded-full dendros-pulse-dot"
                            style={{ background: color, boxShadow: `0 0 8px ${color}` }}
                        />
                        <div
                            className="font-mono text-[10px] uppercase tracking-widest"
                            style={{ color }}
                        >
                            {e.action.replaceAll("_", " ")}
                        </div>
                        <div className="font-body text-sm text-white mt-1">
                            {e.target_contact_name ? `${e.target_contact_name} — ` : ""}
                            <span className="text-zinc-300">{e.details}</span>
                        </div>
                        <div className="font-mono text-[10px] text-zinc-500 mt-1">
                            {formatTime(e.timestamp)} · {e.actor}
                        </div>
                    </li>
                );
            })}
        </ol>
    );
}
